import { render, staticRenderFns } from "./SelfCheckDetailDialog.vue?vue&type=template&id=c96e5054&scoped=true"
import script from "./SelfCheckDetailDialog.vue?vue&type=script&lang=js"
export * from "./SelfCheckDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./SelfCheckDetailDialog.vue?vue&type=style&index=0&id=c96e5054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96e5054",
  null
  
)

export default component.exports